// #region License

/**
 * @license
 * Copyright (C) Mairistem
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 *
 * Proprietary and confidential
 */

// #endregion

import * as React from "react";
import { ApplicationSessionContext } from "./ApplicationSessionContext";
import { UserService } from "../../entities/User";
import { privateApi } from "../../api";
import { useAxios } from "../../utils/axios";

// eslint-disable-next-line max-len
import { jsx as _jsx } from "react/jsx-runtime";
export const ApplicationSessionContextProvider = props => {
  const {
    children
  } = props;
  const {
    Provider
  } = ApplicationSessionContext;
  const [user] = UserService.queryUser();
  const {
    response
  } = useAxios(user);
  React.useEffect(() => {
    const responseId = privateApi.interceptors.response.use(response.data, response.error);
    return () => {
      privateApi.interceptors.response.eject(responseId);
    };
  }, [user]);
  return React.useMemo(() => /*#__PURE__*/_jsx(Provider, {
    value: {
      user
    },
    children: children
  }), [user, children]);
};